import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast, Toaster } from "sonner";
import Login from "./pages/public/Login";
import MainNavigation from "./navigations/main";
import QueueDisplay from "./pages/public/QueueDisplay";
import { connectSocket, disconnectSocket } from "./lib/socket";
import { getSettingsThunk } from "./store/slice/settings-slice";
import { clearUserState } from "./store/slice/users-slice";
import { FORCED_LOGOUT_EVENT } from "./api/config/rootClient";

function App() {
  const dispatch = useDispatch();
  const isLogin = useSelector((s) => s.users.is_login);
  const user = useSelector((s) => s.users.user);

  useEffect(() => {
    if (isLogin) dispatch(getSettingsThunk());
  }, [isLogin, dispatch]);

  // rootClient.js can't import the store directly (see its comment — that
  // cycle crashes the production build), so an unrecoverable auth failure
  // dispatches this plain browser event instead, and gets turned into the
  // real Redux action here.
  useEffect(() => {
    const onForcedLogout = () => dispatch(clearUserState());
    window.addEventListener(FORCED_LOGOUT_EVENT, onForcedLogout);
    return () => window.removeEventListener(FORCED_LOGOUT_EVENT, onForcedLogout);
  }, [dispatch]);

  useEffect(() => {
    if (!isLogin || !user?._id) return;

    const socket = connectSocket(user._id);

    socket.on("call_status_update", (data) => {
      if (data.call_status === "answered") {
        const mins = Math.floor(data.duration_seconds / 60);
        const secs = data.duration_seconds % 60;
        toast.success(`Call answered — ${mins}m ${secs}s`);
      } else {
        toast.error("Call missed");
      }
    });

    return () => {
      disconnectSocket();
    };
  }, [isLogin, user?._id]);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Toaster richColors position="top-right" />
      <Routes>
        {/* A reception TV has no keyboard to log in with — this route bypasses
            the isLogin gate entirely and authenticates via its own ?token=
            query param instead (see QueueDisplay.jsx). */}
        <Route path="/queue-display" element={<QueueDisplay />} />
        <Route path="/*" element={isLogin ? <MainNavigation /> : <Login />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
